<footer>
    <div class="container">
        <p><strong>LoveTech Ventures</strong> © 2020-2021 ALL RIGHTS RESERVED</p>
    </div>
</footer>